import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export interface AccountInfoDTO {
  displayUid: string;
  uid: string;
  name: string;
  currency?: string;
  region?: string;
  salesOrg?: string;
  defaultAccount?: boolean;
  endCustomerCode: string;
  endCustomerName: string;
  endCustomerType: string;
  endCustomerSector: string;
  country: string;
}

export interface AccountListResponseDTO {
  items?: AccountInfoDTO[];
}

export interface AccountInfoData {
  id: string; // Internal FE property - uid is not enough to distinguish entries uniquely
  uid: string;
  number: string; // displayUid
  name: string;
  region: string;
  currency?: string;
  isDefault: boolean;
  salesOrg?: string;
  endCustomerCode: string;
  endCustomerName: string;
  endCustomerType: string;
  endCustomerSector: string;
  country: string;
}

export async function getAccountsData() {
  const url = occUrl("/selectaccount/accounts");
  const response = await occFetch(url);
  const data = (await response.json()) as AccountListResponseDTO;

  const rows: AccountInfoData[] = (data.items ?? []).map((item) => ({
    id: `${item.uid}-${item.salesOrg}-${item.currency}-${item.endCustomerCode}`,
    uid: item.uid,
    number: item.displayUid,
    name: item.name,
    currency: item.currency,
    region: item.region ? item.region : "",
    salesOrg: item.salesOrg,
    isDefault: !!item.defaultAccount,
    isSelected: !!item.defaultAccount,
    endCustomerCode: item.endCustomerCode ? item.endCustomerCode : "",
    endCustomerName: item.endCustomerName ? item.endCustomerName : "",
    endCustomerType: item.endCustomerType ? item.endCustomerType : "",
    endCustomerSector: item.endCustomerSector ? item.endCustomerSector : "",
    country: item.country ? item.country : "",
  }));

  rows.sort((a, b) => {
    const nameComparison = a.name.localeCompare(b.name);
    if (nameComparison !== 0) {
      return nameComparison;
    }
    const endCustomerName = a.endCustomerName.localeCompare(b.endCustomerName);
    if (endCustomerName !== 0) {
      return endCustomerName;
    }
    if (a.currency && b.currency) {
      return a.currency.localeCompare(b.currency);
    }
    return 0;
  });

  return {
    rows,
    selectedAccountId: (rows.find((row) => row.isDefault) ?? rows[0])?.id ?? "",
  };
}
